import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { getPageSameType, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import ReactSVG from 'react-svg';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';

interface IJigsawButton {
  rootStore?: RootStore;
  isFold?: boolean;
}

const JigsawButton = (props: IJigsawButton) => {
  const {isFold} = props;
  const [visible, setVisible] = useState(false);
  const { mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const canShowGalleryButtons = () => {
    // 检测一下当前是否有对应的组件之类的
    let flag = false;
    let { data, video_data } = window.pageDetail;
    if (data) {
      // flag = true;
      let result = getPageSameType(window.pageDetail.template, [], 'photo');
      if (result && result.length) {
        return true;
      }
    }

    return flag;
  };

  useEffect(() => {
    // 初始检测
    setVisible(canShowGalleryButtons());

    const notifyButtonsChange = (e: any) => {
      let action = (e.action || '') as string;
      if (action == 'tab_no_photo') {
        setVisible(false);
      } 
      if (action == 'tab_has_photo') {
        setVisible(true);
      }
    };

    window.addEventListener('PENDENT_CHANGE', notifyButtonsChange);

    return () => {
      window.removeEventListener('PENDENT_CHANGE', notifyButtonsChange);
    };
  }, []);

  const [showLeft, setShowLeft] = useState(false);
  const toggle = () => {
    setShowLeft(!showLeft);
  };

  useEffect(()=>{
    if(isFold) {
      setShowLeft(true);
    }
  }, [isFold]);

  const { galleryStore, wxuserStore } = props.rootStore!;

  const setJigsaw = function(type: string) {
    const visibleEvent = new Event('PENDENT_FOLD');
    visibleEvent.data = 1;
    window.dispatchEvent(visibleEvent);
    galleryStore.setJigsaw({
      type,
      bottomShow: true
    });
    // stat.event(type == 'long' ? 'P_Long' : 'P_Poster');
  };

  return (
    <NormalButton className={`pendant-jigsaw ` + (!visible && 'hide')}>
      {showLeft ? (
        <div
          className={'left-show'}
          style={{ maxWidth: '100%', opacity: 1 }}
          onClick={toggle}
        >
          <div className={'one-item'} data-stat="P_Long" onClick={() => setJigsaw('long')}>
            {intl.get('Long Pic')}
          </div>
          <div className={'one-item'} data-stat="P_Poster" onClick={() => setJigsaw('poster')}>
            {intl.get('Poster')}
          </div>
          <ReactSVG
            src={require('../../svg/right-arrow.svg')}
            style={{
              fill: pendantIconColor,
              height: 15,
              width: 8,
              paddingLeft: 18
            }}
            className="icon"
          />
        </div>
      ) : (
        <div onClick={toggle}>{intl.get('Jigsaw')}</div>
      )}
    </NormalButton>
  );
};

export default inject('rootStore')(observer(JigsawButton));
